import React from 'react';

import Select from '@atlaskit/select';

// eslint-disable-next-line @atlassian/tangerine/import/no-restricted-paths
import { useTimezoneOptions } from '../../../controllers/timezone';

import { type TimezoneOption, type TimezoneSelectProps } from './types';

const TimezoneSelect = (props: TimezoneSelectProps) => {
	const { timezones, loading } = useTimezoneOptions();

	return <Select<TimezoneOption> {...props} options={timezones} isLoading={loading} />;
};

export { TimezoneSelect };
